<template>
  <admin-card title="Страница 'Создайте свой курс'">
    <form @submit.prevent="" @keydown="form.onKeydown($event)">
      <!-- partnership page Title -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('admin.pages.partnership.fields.title') }}</label>
        <div class="col-md-7">
          <input v-model="form.title" type="text" name="title" class="form-control"
                 @change="update()"
                 :class="{ 'is-invalid': form.errors.has('title') }">
          <has-error :form="form" field="title"></has-error>
        </div>
      </div>

      <!-- partnership page Image -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('admin.pages.partnership.fields.image') }}</label>

        <div class="col-md-3">
          <picture-input
            ref="pictureInput"
            @change="imageSelected('image')"
            width="200"
            height="200"
            margin="0"
            accept="image/jpeg,image/png,image/svg"
            size="10"
            buttonClass="btn">
          </picture-input>
          <has-error :form="form" field="image"></has-error>
        </div>
        <div class="col-md-3" v-if="form.image">
          <img style="max-width:100%;" :src="'/images/pages/partnership/' + form.image" />
          <button class="btn btn-warning" @click.prevent="removeImage('image')">{{ $t('admin.global.labels.remove_image') }}</button>
        </div>
      </div>

      <!-- partnership page description -->
      <div class="form-group row">
        <label class="col-md-12 col-form-label text-md-left">{{ $t('admin.pages.partnership.fields.description') }}</label>
        <div class="col-md-12">
          <content-editor @change="update()" v-model="form.description" :options="options" :controls="true"></content-editor>
          <has-error :form="form" field="description"></has-error>
        </div>
      </div>
    </form>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Form } from 'vform'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: this.$t('admin.pages.partnership.labels.edit') }
    },
    extends: AdminPage,
    components: {
    },
    computed: mapGetters({
      partnershipPage: 'pages/page'
    }),
    data: () => ({
      form: new Form({
        id: 0,
        description: '[]',
        title: ''
      }),
      options: {
      }
    }),
    methods: {
      async update () {
        const { data } = await this.form.patch('/api/pages/partnership');

        this.$store.dispatch('pages/updatePage', data);
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
      },

      async removeImage (field) {
        const path = '/api/pages/partnership/images';

        let specialForm = new Form({
          image_name: this.form[field]
        });
        await specialForm.delete(path);

        this.form[field] = '';
        this.update();
      },

      async imageSelected (field) {
        let res;
        const path = '/api/pages/partnership/images';

        let specialForm = new Form({
          image: this.$refs.pictureInput.file,
          old_image_name: ''
        });

        if (this.form.image) {
          specialForm['old_image_name'] = this.form.image;
        }

        const { data } = await specialForm.post(path);
        this.form[field] = data;
        this.update();
      },
    },
    mounted () {
      this.options.postImageUrl = '/api/pages/partnership/images';
      this.options.postFileUrl = '/api/pages/partnership/files';
      this.options.baseImagePath = '/images/pages/partnership';
      this.options.baseFilePath = '/files/pages/partnership';

      this.$store.dispatch('pages/find', 'partnership')
        .then(e => {
          this.form.keys().forEach(key => {
            this.form[key] = this.partnershipPage[key]
          });
        });
    },
    beforeMount () {
    }
  }
</script>
